export default __webpack_public_path__ + "static/media/meg.ec5ac8bb.jpg";